import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';

import useFillProfileData from 'components/Common/Coaches/Hooks/useFillProfileData';

import falseIcon from 'images/icons/checkbox-red-unchecked.svg';
import trueIcon from 'images/icons/checkbox-green-checked.svg';

export default function Index({ row, closePopup }) {
  const data = useFillProfileData(row.id);

  return (
    <Modal
      className="student inmodal auto without-overflow"
      show
      onHide={closePopup}
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {row.attributes.full_name}
          &apos;s Profile Completion
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {data === null && <div>Please wait, loading data ...</div>}
        {data !== null && (
        <div>
          {Object.keys(data.attributes.items).map((key) => (
            <>
              {key === 'Career Level' && <hr /> }
              <div className="item" key={key}>
                {data.attributes.items[key]
                  ? <img src={trueIcon} alt="true" />
                  : <img src={falseIcon} alt="true" />}
                <span className="after-icon" />
                {key}
                {key === 'Career Level'
                  && (
                  <span className="font-9 pl5">
                    SET BY LEGGUP DIRECTOR OF COACHING EXPERIENCE
                  </span>
                  )}
              </div>
            </>
          ))}
        </div>
        )}
      </Modal.Body>
    </Modal>
  );
}

Index.propTypes = {
  row: PropTypes.object.isRequired,
  closePopup: PropTypes.func.isRequired,
};
